import { VBTooltip } from './tooltip';
import { pluginFactory } from '../../utils/plugins';
var VBTooltipPlugin = /*#__PURE__*/pluginFactory({
  directives: {
    VBTooltip: VBTooltip
  }
});
export { VBTooltipPlugin, VBTooltip };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/directives/tooltip/index.js
// module id = 148
// module chunks = 0